import React, { useEffect, useState, useRef } from 'react';
import { SlidersHorizontalIcon } from 'lucide-react';
export interface AnnotationToggles {
  arrivalTimes: boolean;
  paceLines: boolean;
  avgPace: boolean;
  timeDistLabels: boolean;
  elevationGainLoss: boolean;
  stopTimeLabels: boolean;
}
export const DEFAULT_ANNOTATIONS: AnnotationToggles = {
  arrivalTimes: false,
  paceLines: false,
  avgPace: false,
  timeDistLabels: true,
  elevationGainLoss: true,
  stopTimeLabels: false
};
const ANNOTATION_OPTIONS: {
  key: keyof AnnotationToggles;
  label: string;
}[] = [{
  key: 'timeDistLabels',
  label: 'Time & Distance'
}, {
  key: 'elevationGainLoss',
  label: 'Elevation +/-'
}, {
  key: 'arrivalTimes',
  label: 'Arrival Times'
}, {
  key: 'paceLines',
  label: 'Segment Pace'
}, {
  key: 'avgPace',
  label: 'Average Pace'
}, {
  key: 'stopTimeLabels',
  label: 'Stop Times'
}];
interface ChartAnnotationsMenuProps {
  annotations: AnnotationToggles;
  onChange: (annotations: AnnotationToggles) => void;
}
export function ChartAnnotationsMenu({
  annotations,
  onChange
}: ChartAnnotationsMenuProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);
  const toggle = (key: keyof AnnotationToggles) => {
    onChange({
      ...annotations,
      [key]: !annotations[key]
    });
  };
  const reset = () => onChange({
    ...DEFAULT_ANNOTATIONS
  });
  const activeCount = Object.values(annotations).filter(Boolean).length;
  return <div ref={ref} className="relative z-30" data-id="element-1183">
      <button onClick={e => {
      e.stopPropagation();
      setOpen(!open);
    }} className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-[#E8E8ED] bg-white hover:bg-[#FAFAFA] text-[11px] font-semibold text-[#6B6B76] transition-colors shadow-sm" data-id="element-1184">
        <SlidersHorizontalIcon className="h-3.5 w-3.5" data-id="element-1185" />
        <span className="hidden sm:inline" data-id="element-1186">Customize</span>
        {activeCount > 0 && <span className="w-4 h-4 rounded-full bg-[#FC4C02] text-white text-[9px] font-bold flex items-center justify-center" data-id="element-1187">
            {activeCount}
          </span>}
      </button>

      {open && <div className="absolute top-full right-0 mt-1.5 w-52 bg-white rounded-xl border border-[#E8E8ED] shadow-lg p-3 pointer-events-auto z-40" onClick={e => e.stopPropagation()} data-id="element-1188">
          <div className="flex items-center justify-between mb-2.5" data-id="element-1189">
            <span className="text-xs font-bold text-[#2D2D2D]" data-id="element-1190">
              Annotations
            </span>
            <button onClick={reset} className="text-[10px] font-semibold text-[#FC4C02] hover:text-[#E34402] transition-colors" data-id="element-1191">
              Reset
            </button>
          </div>
          <div className="space-y-1" data-id="element-1192">
            {ANNOTATION_OPTIONS.map(({
          key,
          label
        }) => <label key={key} className="flex items-center gap-2.5 py-1.5 px-1 rounded-lg hover:bg-[#FAFAFA] cursor-pointer transition-colors" onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          toggle(key);
        }} data-id="element-1193">
                <div className={`w-4 h-4 rounded flex items-center justify-center border transition-colors ${annotations[key] ? 'bg-[#0666EB] border-[#0666EB]' : 'border-[#D0D0D8] bg-white'}`} data-id="element-1194">
                  {annotations[key] && <svg width="10" height="8" viewBox="0 0 10 8" fill="none" data-id="element-1195">
                      <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1196" />
                    </svg>}
                </div>
                <span className="text-xs font-medium text-[#2D2D2D]" data-id="element-1197">
                  {label}
                </span>
              </label>)}
          </div>
        </div>}
    </div>;
}